import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { GenericError } from '@cian/peperrors/shared';
import { getLogger } from '@cian/logger/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { sendTelemetryTimer as telemetrySendTelemetryTimer, sendTelemetryCounter as telemetrySendTelemetryCounter } from '../telemetry';
/**
 * Хелпер-класс для логирования по яндекс-саджесту в браузере
 * Умеет отправлять телеметрию (с инициализацией начала отсчета времени)
 * Умеет логировать, при этом использует либо error либо warning в зав-ти от поля isStrict
 * */

export var YandexMonitor = /*#__PURE__*/function () {
  function YandexMonitor(config) {
    _classCallCheck(this, YandexMonitor);

    _defineProperty(this, "isStrict", void 0);

    _defineProperty(this, "mcsName", void 0);

    _defineProperty(this, "httpApi", void 0);

    _defineProperty(this, "logger", void 0);

    _defineProperty(this, "trackTelemetryTimer", void 0);

    this.isStrict = config.isStrict;
    this.httpApi = getHttpApi();
    this.logger = getLogger();
    this.mcsName = config.mcsName;
    this.trackTelemetryTimer = this.prepareTelemetryTimerTracker();
  }

  _createClass(YandexMonitor, [{
    key: "loggingMethod",
    get: function get() {
      /** Если не забайндить, контекст теряется и логгер не работает.  */
      return this.isStrict ? this.logger.error.bind(this.logger) : this.logger.warning.bind(this.logger);
    }
  }, {
    key: "prepareTelemetryTimerTracker",
    value: function prepareTelemetryTimerTracker() {
      var _this = this;

      var startTimeRequest = new Date().getTime();
      return function () {
        var endTimeRequest = new Date().getTime() - startTimeRequest;
        telemetrySendTelemetryTimer({
          httpApi: _this.httpApi,
          key: "".concat(_this.mcsName, ".yandex-suggest.timer"),
          value: endTimeRequest
        });
      };
    }
  }, {
    key: "sendTelemetryCounter",
    value: function sendTelemetryCounter() {
      telemetrySendTelemetryCounter({
        httpApi: this.httpApi,
        key: "".concat(this.mcsName, ".yandex-suggest.200")
      });
    }
  }, {
    key: "sendTelemetryTimer",
    value: function sendTelemetryTimer() {
      this.trackTelemetryTimer();
    }
  }, {
    key: "log",
    value: function log(e) {
      this.loggingMethod('Invalid yandex suggest api request', {
        errorMessage: e.message
      });
    }
  }]);

  return YandexMonitor;
}();
/**
 * Эту ошибку следует бросать, когда происходит ошибка внутри яндекс-скрипта
 * Например, такую ошибку можно отловить, если отключить интернет или заблокировать url яндекс саджеста
 * */

export var YandexScriptError = /*#__PURE__*/function (_GenericError) {
  _inherits(YandexScriptError, _GenericError);

  var _super = _createSuper(YandexScriptError);

  function YandexScriptError() {
    var _this2;

    _classCallCheck(this, YandexScriptError);

    var props = {
      message: 'Yandex suggest script error',
      type: YandexScriptError.name,
      domain: ''
    };
    /* istanbul ignore next */

    _this2 = _super.call(this, props);
    Object.setPrototypeOf(_assertThisInitialized(_this2), YandexScriptError.prototype);
    return _this2;
  }

  return _createClass(YandexScriptError);
}(GenericError);